<script>
import { filter } from 'lodash-es';

export default {
    props: {
        searchable: {
            type: Boolean,
            default: true
        },
        label: {
            type: String,
            required: true,
        },
        value: {
            type: [Object],
            default: undefined
        },
        items: {
            type: Array,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledName: {
            type: String,
            default: 'N/A'
        },
        undefinedName: {
            type: String,
            default: 'All items'
        },
        enableDeselect: {
            type: Boolean,
            default: false
        },
        translationPrefix: {
            type: String,
            default: undefined
        }
    },
    data () {
        return {
            toggled: false,
            event: undefined,
            search: '',
            filteredItems: undefined
        }
    },
    created() {
        this.filteredItems = this.items;
    },
    methods: {
        toggle () {
            if (!this.disabled) {
                if (!this.toggled) {
                    this.addListeners();
                } else {
                    this.resetSearch();
                    this.removeListeners();
                }
                this.toggled = !this.toggled;
            }
        },
        keypress (key) {
            this.search += key;
        },
        backSpace () {
            this.search = this.search.substring(0, this.search.length - 1);
        },
        escape () {
            this.toggled = false;
            this.resetSearch();
            this.removeListeners();
        },
        select (val) {
            this.resetSearch();
            this.$emit('input', val);
        },
        deselect () {
            this.resetSearch();
            this.$emit('input', undefined);
        },
        filterSearch () {
            this.filteredItems = filter(this.items, item => {
                return item.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
            })
        },
        clickEvent (event) {
            if (!event.target.classList.contains('key-value-menu__button')) {
                this.toggle();
            }
        },
        addListeners () {
            document.addEventListener('click', this.clickEvent);
            if (this.searchable) {
                document.addEventListener('keydown', this.keypressEvent);
            }
        },
        removeListeners () {
            document.removeEventListener('click', this.clickEvent);
            if (this.searchable) {
                document.removeEventListener('keydown', this.keypressEvent);
            }
        },
        resetSearch() {
            this.search = '';
            this.filteredItems = this.items;
        },
        keypressEvent (event) {
            const key = event.key;
            switch (key) {
            case 'Backspace':
                this.backSpace();
                break;
            case 'Escape':
                this.escape();
                break;
            case 'ArrowUp':
                break;
            case 'ArrowDown':
                break;
            case 'ArrowLeft':
                break;
            case 'ArrowRight':
                break;
            default:
                this.keypress(key);
            }
            this.filterSearch();
        }
    }
}
</script>
<template>
    <div :class="{'key-value-menu--disabled': disabled}"
         class="key-value-menu"
         @click="toggle">
        <div class="key-value-menu__button">
            <div class="key-value-menu__label">
                {{ label }}:
            </div>
            <div v-if="search === ''"
                 class="key-value-menu__value">
                <span v-if="value">
                    {{ value.name }}
                </span>
                <span v-if="!value">
                    {{ disabled ? disabledName : undefinedName }}
                </span>
            </div>
            <div v-if="search !== ''"
                 class="dropdown-menu__search">
                {{ search }}
            </div>
        </div>
        <div v-if="toggled"
             class="key-value-menu__dropdown">
            <div v-if="enableDeselect"
                 :class="{'key-value-menu__choice--selected': !value}"
                 class="key-value-menu__choice"
                 @click="deselect">
                {{ undefinedName }}
            </div>
            <div v-for="(item, index) in filteredItems"
                 :key="'key-value-item__' + index"
                 :class="{'key-value-menu__choice--selected': value === item}"
                 class="key-value-menu__choice"
                 @click="select(item)">
                {{ item.name }}
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/KeyValueMenu/KeyValueMenu.vue